import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';

@Pipe({
  name: 'facilityDetails'
})
export class FacilityDetailsPipe implements PipeTransform {
  private facilitiesList: any;
  constructor(private user: UserService) {
    // Use sync access since data should already be loaded
    const data = this.user.getUpdateInfoSync('facilities');
    this.facilitiesList = data ? data.facilities : [];
  }
  transform(value: any, key: string): any {
    // Fallback to sync access if data wasn't available during construction
    if (!this.facilitiesList || this.facilitiesList.length === 0) {
      const data = this.user.getUpdateInfoSync('facilities');
      this.facilitiesList = data ? data.facilities : [];
    }
    
    let val = this.facilitiesList.filter(fac => {
      return fac.facilityId == value;
    })[0]
    val=val?val[key]:'';
    return val;
  }
}
